import { createToastInterface } from "vue-toastification";

export default function (ctx, inject) {
  const toast = createToastInterface({"cssFile":"\u002Fvar\u002Fwww\u002Fdeployer\u002Fproduction\u002Fnuxt-portal\u002Freleases\u002F166\u002Fnode_modules\u002Fvue-toastification\u002Fdist\u002Findex.css"});
  inject('toast', toast);
}
